import React, {useEffect} from 'react';
import {useSelector, useDispatch} from "react-redux";
import styles from './App.module.scss';
import {
    fetchResults,
    fetchMainFacets,
    setInitialActiveFilters,
    updateFacets,
    populateActiveFiltersIDs
} from "../../Store/Actions/NewFilterActions";
import setNewWindowLocationHash from "../../Utils/setNewWindowLocationHash";
import SearchResultsContainer from "../../containers/SearchResultsContainer/SearchResultsContainer";
import PagerContainer from "../../containers/PagerContainer/PagerContainer";
import Header from "../Header/Header";
import {INITIALIZE, SET_MOBILE} from "../../Store/Actions/ActionTypes";

const App = () => {
    const dispatch = useDispatch();
    const newFilterState = useSelector(state => state.newFilterReducer);
    const responseCache = newFilterState.responseCache;
    const facets = newFilterState.facets;
    const initialized = newFilterState.initialized;
    const activeFilters = newFilterState.activeFilters;
    const thisPage = newFilterState.thisPage;
    const isMobile = newFilterState.isMobile;
    const submittedSearchValue = newFilterState.submittedSearchValue;
    const errors = newFilterState.errors;

    const fetchResultsDispatcher = () => {
        dispatch(fetchResults(responseCache, activeFilters, errors, thisPage));
    };

    // Update the search results whenever needed.
    useEffect(() => {
        // initialized === false: It will only run on the initial page load.
        if (!initialized) {
            if (window.location.hash) {
                // If there is a window hash, go and set the parameters as filters.
                dispatch(setInitialActiveFilters());
            }
            else {
                // There is no window hash, just fetch the results without any filtering.
                fetchResultsDispatcher();
            }
            // Set initialized = true
            dispatch({type: INITIALIZE});
        }
        else {
            // It is already initialized, so just act as usual.
            fetchResultsDispatcher();
        }
    }, [activeFilters, thisPage, submittedSearchValue]);

    // Fetch the main facets, only once.
    useEffect(() => {
        dispatch(fetchMainFacets());
    }, []);

    // @TODO find better solution:
    // When the initial active filters are set above, the main facets have not yet been fetched. As a result, each one
    // of the active filters has only its value in the store and not its id. But this leads to a bug: If for example the
    // main facet Utdanninger is set in the window hash, the active filters do get it in their list (so we can see it in
    // the list of active filters), but the facets menu does not know that this facet is active. So when the user clicks
    // on the main facet Utdanninger in order to filter more, the filters are getting reset.
    // Here we attempt to update the active filters after the initial fetching of main facets, to add the id in them.
    const reducer = (accumulator, currentValue) => accumulator + currentValue;
    const mainFacetKeys = Object.keys(facets).reduce(reducer, '');
    useEffect(() => {
        if (mainFacetKeys) {
            dispatch(populateActiveFiltersIDs(activeFilters, facets, responseCache));
        }
    }, [mainFacetKeys]);



    // Update the window hash query parameters every time the active filters are changing.
    useEffect(() => {
        if (initialized) {
            setNewWindowLocationHash(activeFilters);
        }
    }, [activeFilters]);

    // Update the facet values every time there's a change in the filters.
    useEffect(() => {
        // @TODO improvement: Right now, every time a facet is (de)selected, all the available facet groups will be
        // updated because of this hook. So, for example, if the user has selected Utdanninger > Universitet og høgskole
        // there will be 6 groups (3 from the main facet + 3 extra) which means that for each change on the facets there
        // will be 6 requests fired up (+1 for the results themselves).
        // Possible solution: Create another state variable "expiredCaches". This hook can add all the groups to
        // expiredCaches, and will NOT fire up the requests. When a group is activated, the expiredCaches will be checked
        // and, if needed, the request will be fired up.
        dispatch(updateFacets(responseCache, facets, activeFilters));
    }, [activeFilters]);

    // Initialize the view mode.
    useEffect(() => {
        let mobile = window.innerWidth <= 900;
        dispatch({type: SET_MOBILE, payload: mobile});
    }, []);

    // Handle window resize.
    const handleResize = () => {
        let mobile = window.innerWidth <= 900;
        dispatch({type: SET_MOBILE, payload: mobile});
    }
    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, []);


    return (
        <div className={styles.rootwrapper}>
            <a href="#main-content" className={styles.skiplink}>
                Hopp til hovedinnhold
            </a>
            <div className={styles.notfooter}>
                {/* <HeaderTop/> */}
                <Header isMobile={isMobile}/>

                {/* The active filters are placed in a different position in mobile than in desktop. */}
                {/* {!isMobile &&
                <ActiveFiltersContainer/>
                } */}

                <SearchResultsContainer />

                <PagerContainer/>
            </div>
            {/* <Footer/> */}
        </div>
    );
}
export default App;
